export default __webpack_public_path__ + "static/media/calculations.71611545.png";